import {InitializationAndConfigurationService} from '../configuration/initializationAndConfiguration.service';
import {Injectable} from '@angular/core';

@Injectable()
export class ConfigurableStylingService {
    stylingConfig: any;

    constructor(
        private initializationAndConfigurationService: InitializationAndConfigurationService
    ) {
        initializationAndConfigurationService.getConfiguration().subscribe((cfg) => {
            var json = cfg.stylingConfig;
            if (json) {
                this.stylingConfig = JSON.parse(json);
            } else {
                this.stylingConfig = {};
            }
        });
    }

    getStylingInfo(domainName, categoryName) {
        let stylingInfo = null;

        const domain = this.stylingConfig[domainName];
        if (domain) {
            var category = domain[categoryName];
            if (category) {
                stylingInfo = category;
            } else {
                category = domain['default'];
                if (category) {
                    stylingInfo = category;
                }
            }
        }

        return stylingInfo;
    }
}
